<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">勤怠マスタデータのインポート</span>
			</div>
			<div class="uk-navbar-right">
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div class="uk-align-right">
				<router-link class="uk-button uk-button-default" to="/main_office">戻る</router-link>
			</div>
		</div>
		<!--/ Main -->
		<h1 class="uk-heading-divide ruk-padding uk-text-center">インポート</h1>
		<div class="uk-margin uk-padding uk-text-center">
			<input id="file" type="file">
		</div>
		<div class="uk-margin uk-padding uk-text-center">
			<p>指定されたファイルをインポートします。よろしいですか。</p>
		</div>
		<div class="uk-margin uk-padding uk-text-center">
			<button class="uk-button uk-button-default" @click="upload">インポート</button>
		</div>
		<div class="uk-margin uk-padding uk-text-center">
			<p>インポートには時間がかかります。</p>
			<p>ステータスが異常になった場合は、インポートをやり直してください。</p>
			<p>最終更新日時: {{ last_updated | moment }}</p>
		</div>
	</div>
</template>

<script>

	import CsvImport from '@/api/CsvImport'
	import StaffAuth from '@/api/StaffAuth'
	import Role from '@/api/Role'
	import MainOfficeAuth from '@/api/MainOfficeAuth'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	import Tag from '@/api/Tag'

	export default {
		name: 'MainOfficeImportWorkSchedulePage',
		comments: [],
		data () {
			return {
				last_updated: null
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY/MM/DD HH:mm')
			}
		},
		methods: {
			clickLogoutButton () {
				let self = this

				let return_url = '/main_office/login'

				// StaffAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							MainOfficeAuth.logout().then(function (response) {
								self.$router.push(return_url)
								location.reload()
							})
						// })
					// })
				// })
			},
			upload () {
				let self = this
				let params = new FormData()
				params.append('file', $('#file')[0].files[0])

				CsvImport.importStaffWorkScheduleForMainOffice(params).then(function (response) {
					alert(response.data.data + '件のインポート完了')
					self.last_updated = response.data.time
				}, function () {
					alert('ERROR')
				})
			}
		},
		created () {
		},
		beforeMount () {
		},
		mounted () {
			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_main_office != true) { // 権限が無い場合
					self.$router.push('/main_office/login')
				}
			})

			let params = new URLSearchParams()
			params.append('key', 'last_import_work_schedule_code_time')

			Tag.one(params).then(function (response) {
				self.last_updated = moment(response.data.data.value).format('YYYY-MM-DD HH:mm:ss')
			})
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/MainOfficeImportWorkSchedulePage.vue